import React, { type FunctionComponent } from 'react';
import { useCustomer } from '../../../../hooks/apollo/customer/customer.hooks';
import { EcoRebatesWidgetTypes, useGetEcoRebatesWidgetScript } from '../../../../hooks/eco-rebates/eco-rebates.hooks';

export const RebateCenterWidget: FunctionComponent = () => {
	useGetEcoRebatesWidgetScript(EcoRebatesWidgetTypes.REBATE_CENTER);
	const { data } = useCustomer();

	// Creating the custom element <ecr-rebate-center-widget> to allow third-party script to render the widget
	// Using React.createElement since the custom element is not recognized by TypeScript
	return React.createElement('ecr-rebate-center-widget', {
		zip: data?.customer?.location?.zipCode,
		'data-testid': 'ecr-rebate-center-widget',
		viewProductText: 'View Product'
	});
};
